import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "GroupContainer"
}
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
		'EnrolmentsTableGroupSelector',
		_ctx.isInternal ? 'InternalGroupSelector' : ''
	])
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("label", { class: "EnrolmentsGroupingOptionsLabel" }, " Group by: ", -1 /* CACHED */)),
    (_ctx.selectedGroup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupSelector.options, (option) => {
            return (_openBlock(), _createElementBlock("div", {
              key: option.getHashKey(),
              class: _normalizeClass(["GroupOption", { DefaultFilter: _ctx.groupSelector.defaultOption.equals(option) }])
            }, [
              _createElementVNode("a", {
                class: _normalizeClass({ GroupActive: _ctx.selectedGroup.equals(option) }),
                onClick: ($event: any) => (_ctx.changeGroupOption(option))
              }, _toDisplayString(option.displayText), 11 /* TEXT, CLASS, PROPS */, _hoisted_2)
            ], 2 /* CLASS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}